import React from 'react';
import ReactDOM from 'react-dom/client';
import '@linktivity/link-styles';
import '@sagano/agent/styles/index.css';
import '@sagano/agent/i18n';
import App from '@sagano/agent/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
